export default [
  { level: 1, title: "rising star" },
  { level: 2, title: "bronze" },
  { level: 3, title: "silver" },
  { level: 4, title: "gold" }
];
